export default __webpack_public_path__ + "static/media/5.6769da0a.png";